import { render } from "./DemographicsInformation.vue?vue&type=template&id=fc0896d2&ts=true"
import script from "./DemographicsInformation.ts?vue&type=script&lang=ts&external"
export * from "./DemographicsInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__